import React, { useRef } from 'react';
import { useNavigateAndScroll } from '../../Hooks/useNavigateAndScroll';

const NewPatient = () => {
  const barRef = useRef(null);
  const navigateAndScroll = useNavigateAndScroll();
  const infoCardsData = {
    newPatient: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/New+Pt+registration.webp',
      infoTitle: 'New Patient Registration',
      infoText: 'Quickly register online for your first visit. Fill out personal, insurance, and health history details to get started with our practice in just a few minutes.',
      path: '/patient-center/new-patient'
    },
    patientForms: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Patient+forms.webp',
      infoTitle: 'Patient Forms',
      infoText: 'Access all necessary intake and consent forms to streamline your visit. Download, complete, and upload them securely before your appointment.',
      path: '/patient-center/patient-forms'
    },
    refillRequests: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Med+refill.webp',
      infoTitle: 'Refill Requests',
      infoText: 'Submit medication refill requests online anytime. Our team will process them promptly and notify you when they’re ready for pickup or sent to your pharmacy.',
      path: '/patient-center/refill-requests'
    },
    officePolicies: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Office+Policy.webp',
      infoTitle: 'Office Policies',
      infoText: 'Review our appointment, cancellation, and billing policies to ensure a smooth experience. Everything you need to know about visits, payments, and patient responsibilities.',
      path: '/patient-center/office-policies'
    },
    faqs: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/FAQ.webp',
      infoTitle: "FAQ's",
      infoText: 'Find quick answers to the most common questions—hours of operation, new patient procedures, after-hours care, and more—all in one place.',
      path: '/patient-center/faqs'
    }
  };
  return (
    <div>
    <div className="relative w-auto z-1 mt-[-70px]">
          <img
            className="w-full h-auto rounded-lg shadow-lg mt-2"
            src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/new+patient+sub.webp"
            alt="Mother and child meeting a doctor"
          />
        </div>
    <div ref={barRef} className="sticky top-0 flex justify-around bg-custom-blue text-white z-50">
        {Object.values(infoCardsData).map((card) => (
          <button
            key={card.infoTitle}
            className="p-1 text-sm cursor-pointer grow-text"
            onClick={() => navigateAndScroll(card.path, card.infoTitle)}
          >
            {card.infoTitle}
          </button>
        ))}
      </div>
    <div className="w-full px-4 py-8 sm:px-6 lg:px-64">
      <h2 className="text-4xl font-bold text-gray-800 mb-2">New Pediatric Patients</h2>
      <hr className="border-t-2 border-blue-500 mb-6" />
      
      <div className="space-y-6">
        <section>
          <p className="mb-4 text-gray-600">
            Central Illinois Pediatric Associates welcomes new patients. Choosing the right pediatrician for your child is one of the most important decisions you will make. By selecting Central Illinois Pediatric Associates, you can feel confident and comfortable that you have made the right decision.
          </p>
          <p className="mb-4 text-gray-600">
            To understand what to expect for your child's first visit to our practice, please read through this page.
          </p>
        </section>

        <section>
          <h3 className="text-2xl font-bold text-gray-800 mb-2">Our Mission</h3>
          <p className="mb-4 text-gray-600">
            Our practice is working together to build life-long relationships between our staff and our patients by consistently providing our patients with compassion, excellence and value. To fulfill this mission, we are committed to:
          </p>
          <ul className="list-disc list-outside ml-5 text-gray-600 space-y-2">
            <li>Improving the lives of the children we serve by providing quality care in a child-centered environment.</li>
            <li>Listening to our young patients and their families who we are privileged to serve.</li>
            <li>Guiding our patients along a path of optimal health and wellness.</li>
            <li>Continually pursuing excellence at all levels through continuing education.</li>
          </ul>
        </section>

        <section>
          <h3 className="text-2xl font-bold text-gray-800 mb-2">What to bring to your first visit?</h3>
          <p className="mb-4 text-gray-600">
            We work hard to ensure that your child receives prompt medical care in a comfortable, child-friendly office setting. To help expedite the first appointment, we ask that you please bring your child's immunization records and be prepared to complete paperwork regarding your family medical history, your child's medical history, and insurance information.
          </p>
        </section>

       

        <section>
          <h3 className="text-2xl font-bold text-gray-800 mb-2">What to Expect</h3>
          <p className="mb-4 text-gray-600">
            On the day of your child's first visit to our office, we recommend arriving a few minutes early. This allows extra time for finishing up any registration forms and ensures you have plenty of time to get acquainted with our staff and office. We look forward to meeting you and joining with you to help your child maintain optimal health.
          </p>
        </section>

        <section>
          <h3 className="text-2xl font-bold text-gray-800 mb-2">Directions</h3>
          <ul className="list-disc list-outside ml-5 text-gray-600 space-y-2">
            <li>We are located on Maloney Drive which connects Prospect Rd. and Williamsburg Dr. between Eastland Dr. and E. Washington St..</li>
            <li>You can reach our office from Prospect Rd. turning east on to Maloney Dr. at the corner of Friar Tuck and First State Bank.</li>
            <li>You can also reach our office from Williamsburg Dr. turning west on to Maloney Dr. at the corner of Houska Dental Office and Bright Horizon child care.</li>
            <li>Our office is next to Houska Dental Office and across the street from Bright Horizon child care.</li>
          </ul>
        </section>
      </div>
    </div>
    </div>
  );
};

export default NewPatient;